<template>
  <div style="height: 100%">
    <div class="breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">
          <span style="color: #4a90e2">
            <i class="el-icon-location"></i>
            {{ $t('detail.首页') }}
          </span>
        </el-breadcrumb-item>
        <el-breadcrumb-item>
          {{ equipmentnm || '测试页面' }}
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div id="form" v-if="equipHead">
      <el-card class="box-card" shadow="never">
        <div class="box-container">
          <!-- 需折叠部分 -->
          <el-collapse v-if="showData || myequips">
            <el-collapse-item :title="$t('detail.配置参数')">
              <el-form ref="form" label-position="top" :model="form" label-width="80px">
                <div class="flexbox">
                  <div>
                    <el-form-item>
                      <div class="flexbox1">
                        <div class="word">
                          <span slot="label">{{ $t('detail.设备名') }}</span>
                        </div>
                        <div class="first">
                          <el-input :readonly="true" :disabled="disConfig" v-model="equipHead.enm"></el-input>
                        </div>
                      </div>
                    </el-form-item>
                  </div>
                  <div>
                    <el-form-item>
                      <div class="flexbox1">
                        <div class="word">
                          <span slot="label">{{ $t('detail.设备编号') }}</span>
                        </div>
                        <div class="second">
                          <el-input :readonly="true" :disabled="disConfig" v-model="equipHead.eno"></el-input>
                        </div>
                      </div>
                    </el-form-item>
                  </div>
                </div>
                <div class="flexbox">
                  <div>
                    <el-form-item>
                      <div class="flexbox1">
                        <div class="word">
                          <span slot="label">{{ $t('detail.设备名称') }}</span>
                        </div>
                        <div class="third">
                          <el-input :readonly="true" :disabled="disConfig" v-model="equipHead.epnm"></el-input>
                        </div>
                      </div>
                    </el-form-item>
                  </div>
                  <div>
                    <el-form-item>
                      <div class="flexbox1">
                        <div class="word">
                          <span slot="label">{{ $t('detail.北斗更新时间') }}</span>
                          <div>{{ $t('detail.整点') }}</div>
                        </div>
                        <div class="fourth">
                          <el-select
                            class="seltime2"
                            :no-data-text="$t('home.noData')"
                            :disabled="disConfig"
                            v-model="equipHead.etime"
                            :placeholder="$t('detail.时间')"
                          >
                            <el-option v-for="n in List" :key="n.id" :value="n.text">{{ n.text }}</el-option>
                          </el-select>
                        </div>
                      </div>
                    </el-form-item>
                  </div>
                </div>
                <div class="flexbox">
                  <div>
                    <el-form-item>
                      <div class="flexbox1">
                        <div class="word">
                          <span slot="label">{{ $t('detail.偏移量') }}{{ $t('detail.米') }}</span>
                        </div>
                        <div class="fifth">
                          <el-input :disabled="disConfig" v-model="equipHead.offsize"></el-input>
                        </div>
                      </div>
                    </el-form-item>
                  </div>
                  <div>
                    <el-form-item>
                      <div class="flexbox1">
                        <div class="word">
                          <span slot="label">{{ $t('detail.终端采样频率') }}{{ $t('detail.分') }}</span>
                        </div>
                        <div class="sixth">
                          <el-input :disabled="disConfig" v-model="equipHead.dataspan"></el-input>
                        </div>
                      </div>
                    </el-form-item>
                  </div>
                </div>
                <div class="flexbox">
                  <div>
                    <el-form-item>
                      <div class="flexbox1">
                        <div class="word">
                          <span slot="label">{{ $t('detail.基准纬度') }}{{ $t('detail.度') }}</span>
                        </div>
                        <div class="seventh">
                          <el-input :disabled="disConfig" v-model="equipHead.standardwd"></el-input>
                        </div>
                      </div>
                    </el-form-item>
                  </div>
                  <div>
                    <el-form-item>
                      <div class="flexbox1">
                        <div class="word">
                          <span slot="label">{{ $t('detail.基准经度') }}{{ $t('detail.度') }}</span>
                        </div>
                        <div class="eighth">
                          <el-input :disabled="disConfig" v-model="equipHead.standardjd"></el-input>
                        </div>
                      </div>
                    </el-form-item>
                  </div>
                </div>
                <div class="flexbox">
                  <div>
                    <el-form-item>
                      <div class="flexbox1">
                        <div class="word">
                          <span slot="label">{{ $t('detail.无信号报警间隔') }}{{ $t('detail.分') }}</span>
                        </div>
                        <div class="fifth">
                          <el-input :disabled="disConfig" v-model="equipHead.noalertspan"></el-input>
                        </div>
                      </div>
                    </el-form-item>
                  </div>
                  <div>
                    <el-form-item>
                      <div class="flexbox1">
                        <div class="word">
                          <span slot="label">{{ $t('detail.报警刷新时间') }}</span>
                        </div>
                        <div class="sixth">
                          <el-row>
                            <el-col :span="18">
                              <el-input :disabled="disConfig" v-model="equipHead.lastupdatetime" :readonly="true"></el-input>
                            </el-col>
                            <el-col :span="6">
                              <el-button style="margin-left: 10px" @click.native="dialogVisibleFire = true">{{ $t('detail.查看') }}</el-button>
                            </el-col>
                          </el-row>
                        </div>
                      </div>
                    </el-form-item>
                  </div>
                </div>

                <div class="flexbox">
                  <div>
                    <el-form-item>
                      <div class="flexbox">
                        <div>
                          <span slot="label">{{ $t('detail.偏移报警') }}</span>
                        </div>
                        <div class="bb">
                          <el-switch :disabled="disConfig" v-model="equipHead.overflag" :active-value="1" :inactive-value="0" />
                        </div>
                      </div>
                    </el-form-item>
                  </div>
                  <div>
                    <el-form-item>
                      <div class="flexbox">
                        <div class="cc">
                          <span slot="label">{{ $t('detail.超时报警') }}</span>
                        </div>
                        <div class="bb">
                          <el-switch :disabled="disConfig" v-model="equipHead.nodataflag" :active-value="1" :inactive-value="0" />
                        </div>
                      </div>
                    </el-form-item>
                  </div>
                  <div>
                    <el-form-item>
                      <div class="flexbox">
                        <div class="cc">
                          <span slot="label">{{ $t('detail.开舱漏水报警') }}</span>
                        </div>
                        <div class="bb">
                          <el-switch :disabled="disConfig" v-model="equipHead.waterflag" :active-value="1" :inactive-value="0" />
                        </div>
                      </div>
                    </el-form-item>
                  </div>
                </div>
                <div>
                  <button type="button" class="btn-save" :disabled="disConfig" @click="saveequipinfo()">{{ $t('detail.保存') }}</button>
                </div>
                <el-form-item :label="$t('detail.设备可见用户')">
                  <el-button type="primary" style="margin-bottom: 15px" @click="dialog">+ {{ $t('detail.添加可见用户') }}</el-button>
                  <el-card class="box-card" shadow="never">
                    <div v-for="n in shareuser" :key="n.uid">
                      <div>
                        {{ n.uid }} - {{ n.unm }} - {{ n.phone }}
                        <button type="button" :disabled="disConfig" @click="removeShare(equipid, n.uid)">{{ $t('detail.移除共享') }}</button>
                      </div>
                    </div>
                  </el-card>
                </el-form-item>
              </el-form>
            </el-collapse-item>
          </el-collapse>

          <!-- 无需折叠部分 -->
          <div style="margin-bottom: 8px; margin-top: 10px">{{ $t('detail.设备数据') }}</div>
          <div class="block" style="margin-top: 12px; margin-bottom: 12px">
            <el-date-picker v-model="daterange" type="date" :placeholder="$t('detail.开始日期')" value-format="yyyy-MM-dd"></el-date-picker>
            {{ $t('detail.至') }}
            <el-date-picker
              v-model="daterangeend"
              type="date"
              :placeholder="$t('detail.结束日期')"
              value-format="yyyy-MM-dd"
              @change="change"
            ></el-date-picker>
            <el-button type="primary" style="margin-left: 10px" @click="change">{{ $t('detail.确定') }}</el-button>
            <modal name="example" :shiftX="1" :shiftY="1" :focusTrap="false">
              <iframe src="/#/mapFrame/6" frameborder="0" width="100%" height="100%"></iframe>
            </modal>
          </div>
          <el-table :data="equipinfoList" ref="myTable" v-if="equipHead != null && equipHead.tp.length != 0 && isstyle" height="100%">
            <el-table-column prop="info.createtime" :label="$t('detail.时间')" fixed="left" width="140"></el-table-column>
            <el-table-column prop="info.jdt" :label="$t('detail.经度')" width="120"></el-table-column>
            <el-table-column prop="info.wdt" :label="$t('detail.纬度')" width="120"></el-table-column>
            <template v-if="equipHead.tp.length != 0">
              <el-table-column v-for="(tnm, index) in equipHead.tp" :key="tnm.tnm" :label="getLocalName(tnm.tnm)">
                <template slot-scope="scope">
                  <div :style="{ whiteSpace: 'nowrap' }">{{ scope.row.list[index] }}</div>
                </template>
              </el-table-column>
            </template>
          </el-table>

          <!-- 分页 -->
          <el-pagination
            v-if="equipinfoList && equipinfoList.length"
            @current-change="handleCurrentChange"
            layout="total, prev, pager, next"
            :current-page="currentPage"
            :page-size="pagesize"
            :total="this.total"
          ></el-pagination>
          <div style="margin-top: 10px">
            <el-button type="primary" style="" @click="exportToExcel" v-if="showData || myequips">{{ $t('detail.设备报表下载') }} >> excel</el-button>
          </div>
        </div>
      </el-card>
    </div>
    <el-dialog width="500px" :title="$t('detail.添加可访问用户')" :center="true" v-if="equipHead" :visible.sync="dialogFormVisible">
      <el-form :model="form">
        <el-form-item :label="$t('detail.设备编码')" :label-width="formLabelWidth">
          <el-input readonly v-model="equipid" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item :label="$t('detail.用户名')" :label-width="formLabelWidth">
          <el-input v-model="equip.usernm" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item :label="$t('detail.手机号')" :label-width="formLabelWidth">
          <el-input v-model="equip.phone" auto-complete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">{{ $t('detail.取消') }}</el-button>
        <el-button type="primary" @click="addequip()">{{ $t('detail.确定') }}</el-button>
      </div>
    </el-dialog>
    <el-dialog :title="$t('detail.报警列表')" :visible.sync="dialogVisibleFire" width="80%">
      <div>
        <el-table :data="fireList" style="width: 100%" max-height="550">
          <el-table-column fixed prop="Id" :label="$t('detail.设备编号')" width="150"></el-table-column>
          <el-table-column prop="EquipNo" :label="$t('detail.设备信息表ID')" width="120"></el-table-column>
          <el-table-column prop="EquipTypeId" :label="$t('detail.设备类型ID')" width="120"></el-table-column>
          <el-table-column prop="GpsTime" :label="$t('detail.GPS时间')" width="120"></el-table-column>
          <el-table-column prop="Longitude" :label="$t('detail.经度')" width="120"></el-table-column>
          <el-table-column prop="Latitude" :label="$t('detail.纬度')" width="120"></el-table-column>

          <el-table-column :label="$t('detail.一路温度')" width="120">
            <template slot-scope="scope">{{ scope.row.T1 }} ℃</template>
          </el-table-column>
          <el-table-column :label="$t('detail.二路温度')" width="120">
            <template slot-scope="scope">{{ scope.row.T2 }} ℃</template>
          </el-table-column>
          <el-table-column :label="$t('detail.三路温度')" width="120">
            <template slot-scope="scope">{{ scope.row.T3 }} ℃</template>
          </el-table-column>
          <el-table-column prop="H1" :label="$t('detail.一路湿度')" width="120"></el-table-column>
          <el-table-column prop="H2" :label="$t('detail.二路湿度')" width="120"></el-table-column>
          <el-table-column prop="H3" :label="$t('detail.三路湿度')" width="120"></el-table-column>

          <el-table-column :label="$t('detail.是否开仓')" width="120">
            <template slot-scope="scope">
              {{ scope.row.IsOpen == '1' ? $t('detail.是') : $t('detail.否') }}
            </template>
          </el-table-column>

          <el-table-column fixed="right" :label="$t('detail.操作')" width="120">
            <template slot-scope="scope">
              <el-button
                @click.native.prevent="deleteRow(scope.$index, fireList, scope.row)"
                :disabled="scope.row.IsDeleted == 0 ? false : true"
                type="primary"
                size="small"
              >
                {{ scope.row.IsDeleted == 0 ? $t('detail.确定') : $t('detail.已读') }}
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { Toast } from 'vant'
import { equipinfo, sharedequip, equiphistory, cancelshard, saveequipinfo, getEquipNotice, updateEquipNotice } from '../service/getData'

import { getToken } from '../utils/auth'
import moment from 'moment'

let setTimeOpenMsg = null
export default {
  name: 'app',
  props: ['breadcrumb'],
  data() {
    return {
      // 是否为我的设备
      myequips: false,
      disConfig: false,
      excelName:
        `${this.equipmentnm}-${this.equipmentno}-${moment(this.dbt).format('YYYYMMDD')}-${moment(this.edt).format('YYYYMMDD')}.xls` || '设备报表.xls',
      json_data: null,
      json_fields: {
        'Complete name': 'name',
        Date: 'date',
      },
      pagesize: 40,
      pnum: 6000,
      currentPage: 1,
      total: 0,
      List: [
        { id: '1', text: '00', value: `id=1,${this.$t('detail.选择了')}00` },
        { id: '2', text: '01', value: `id=2,${this.$t('detail.选择了')}01` },
        { id: '3', text: '02', value: `id=3,${this.$t('detail.选择了')}02` },
        { id: '4', text: '03', value: `id=4,${this.$t('detail.选择了')}03` },
        { id: '5', text: '04', value: `id=5,${this.$t('detail.选择了')}04` },
        { id: '6', text: '05', value: `id=6,${this.$t('detail.选择了')}05` },
        { id: '7', text: '06', value: `id=7,${this.$t('detail.选择了')}06` },
        { id: '8', text: '07', value: `id=8,${this.$t('detail.选择了')}07` },
        { id: '9', text: '08', value: `id=9,${this.$t('detail.选择了')}08` },
        { id: '10', text: '09', value: `id=10,${this.$t('detail.选择了')}09` },
        { id: '11', text: '10', value: `id=11,${this.$t('detail.选择了')}10` },
        { id: '12', text: '11', value: `id=12,${this.$t('detail.选择了')}11` },
        { id: '13', text: '12', value: `id=13,${this.$t('detail.选择了')}12` },
        { id: '14', text: '13', value: `id=14,${this.$t('detail.选择了')}13` },
        { id: '15', text: '14', value: `id=15,${this.$t('detail.选择了')}14` },
        { id: '16', text: '15', value: `id=16,${this.$t('detail.选择了')}15` },
        { id: '17', text: '16', value: `id=17,${this.$t('detail.选择了')}16` },
        { id: '18', text: '17', value: `id=18,${this.$t('detail.选择了')}17` },
        { id: '19', text: '18', value: `id=19,${this.$t('detail.选择了')}18` },
        { id: '20', text: '19', value: `id=20,${this.$t('detail.选择了')}19` },
        { id: '21', text: '20', value: `id=21,${this.$t('detail.选择了')}20` },
        { id: '22', text: '21', value: `id=22,${this.$t('detail.选择了')}21` },
        { id: '23', text: '22', value: `id=23,${this.$t('detail.选择了')}22` },
        { id: '24', text: '23', value: `id=24,${this.$t('detail.选择了')}23` },
      ],

      daterange: moment().subtract(1, 'year').format('YYYY-MM-DD'),
      daterangeend: moment().format('YYYY-MM-DD'),
      // 开始时间
      dbt: null || moment().subtract(1, 'year').format('YYYY-MM-DD'),
      // 结束时间
      edt: null || moment().format('YYYY-MM-DD'),
      pickerOptionsStart: {
        disabledDate: (time) => {
          let endDateVal = this.daterangeend
          if (endDateVal) {
            return time.getTime() > new Date(endDateVal).getTime() || time.getTime() > Date.now()
          }
        },
      },
      pickerOptionsEnd: {
        disabledDate: (time) => {
          let beginDateVal = this.daterange
          if (beginDateVal) {
            return time.getTime() < new Date(beginDateVal).getTime() - 1 * 24 * 60 * 60 * 1000 || time.getTime() > Date.now()
          }
        },
      },
      equip: {
        equipno: null,
        usernm: null,
        phone: null,
      },
      equipmentnm: this.$route.query.equipmentnm,
      equipmentno: this.$route.query.equipmentno,
      equipid: this.$route.params.dId,

      form: {
        name: '',
        region: '',
        date1: '',
        date2: '',
        delivery: false,
        type: [],
        resource: '',
        desc: '',
      },
      dialogTableVisible: false,
      dialogFormVisible: false,
      formLabelWidth: '120px',
      equipinfoList: [],
      equipinfoList1: [],
      equipHead: null,
      shareuser: null,
      //是否展示配置参数
      showData: null,
      fireList: null,
      dialogVisibleFire: false,
      isstyle: false,
    }
  },
  methods: {
    vueModel() {
      this.$modal.show('example')
    },
    // 是否开舱报警
    getIsOpen() {
      return (this.fireList && this.fireList.some((item) => item.IsDeleted == 0 && item.IsOpen == '1') && 1) || 0
    },
    async deleteRow(index, rows, row) {
      let res = await updateEquipNotice(row.Id)
      if (res.data.ResultType == 0) {
        // row.IsDeleted == 1
        rows.map((n) => {
          if (n.Id === row.Id) n.IsDeleted = 1
        })
        // rows.splice(index, 1)
      } else {
        this.$message(this.$t('detail.操作失败'))
      }
    },
    getLocalName(name) {
      return this.$t(`detail.${name}`)
    },
    async openNotice() {
      // 只查询30分钟内有报警的数据
      let res = await getEquipNotice(
        this.equipid,
        moment().subtract(1, 'hours').format('YYYY-MM-DD HH:mm:ss'),
        moment().format('YYYY-MM-DD HH:mm:ss')
      )
      let msgs = res.data.AppendData || []
      this.fireList = msgs
      let tempmsg = ``
      msgs.map((msg) => {
        if (msg.IsDeleted != 0) return false
        tempmsg += `
  <div class="fire-wrap">
    <div class="fire-row">
      <div class="fire-row-item">
        GPS${this.$t('detail.时间')}  <!-- 用 this.$t() 获取翻译，直接拼接 -->
      </div>
      <div class="fire-row-item">
        ${msg.GpsTime}
      </div>
    </div>
    <div class="fire-row">
      <div class="fire-row-item">
        ${this.$t('detail.一路温度')}  <!-- 修正：去掉 {{ }}，用 this.$t() -->
      </div>
      <div class="fire-row-item">
        ${msg.T1} ℃
      </div>
    </div>
    <div class="fire-row">
      <div class="fire-row-item">
        ${this.$t('detail.二路温度')}
      </div>
      <div class="fire-row-item">
        ${msg.T2} ℃
      </div>
    </div>
    <div class="fire-row">
      <div class="fire-row-item">
        ${this.$t('detail.三路温度')}
      </div>
      <div class="fire-row-item">
        ${msg.T3} ℃
      </div>
    </div>
    <div class="fire-row">
      <div class="fire-row-item">
        ${this.$t('detail.一路湿度')}
      </div>
      <div class="fire-row-item">
        ${msg.H1}
      </div>
    </div>
    <div class="fire-row">
      <div class="fire-row-item">
        ${this.$t('detail.二路湿度')}
      </div>
      <div class="fire-row-item">
        ${msg.H2}
      </div>
    </div>
    <div class="fire-row">
      <div class="fire-row-item">
        ${this.$t('detail.三路湿度')}
      </div>
      <div class="fire-row-item">
        ${msg.H3}
      </div>
    </div>
    <div class="fire-row">
      <div class="fire-row-item">
        ${this.$t('detail.是否开仓')}
      </div>
      <div class="fire-row-item">
        ${msg.IsOpen ? this.$t('detail.是') : this.$t('detail.否')}
      </div>
    </div>
  </div>
        `
      })
      if (!tempmsg) return false
      this.$notify.error({
        title: this.$t('detail.报警信息提示'),
        dangerouslyUseHTMLString: true,
        message: tempmsg,
        duration: 0,
        onClose() {},
      })
    },
    /**
     * 消息报警（每5分钟一次）
     */
    async openMsg() {
      // clearInterval(setTimeOpenMsg)
      setTimeOpenMsg = setInterval(async () => {
        this.openNotice()
      }, 1000 * 60 * 5)
    },
    async saveequipinfo() {
      console.log(this.equipHead)
      let res = await saveequipinfo(this.equipHead, this.equipid)
      if (res.data.Message === this.$t('detail.修改操作成功')) {
        Toast(this.$t('detail.保存成功'))
        await equipinfo(this.equipid)
        // this.equipinfo()
      } else {
        Toast(this.$t('detail.保存失败'))
      }
    },
    async change(v) {
      if (v != null && v.length != 0) {
        this.dbt = this.daterange
        this.edt = this.daterangeend
      }
      //this.equipid = this.$route.params.dId
      this.equipid = this.$route.query.equipid
      this.equipmentnm = this.$route.query.equipmentnm
      this.equipmentno = this.$route.query.equipmentno
      this.equipinfo()
      this.downLoad()
    },
    onSubmit() {
      this.$alert(this.$t('detail.这是一段内容'), this.$t('detail.标题名称'), {
        confirmButtonText: this.$t('detail.确定'),
        callback: (action) => {
          this.$message({
            type: 'info',
            message: `action: ${action}`,
          })
        },
      })
    },
    //添加可见用户
    async addequip() {
      let result = await sharedequip(this.equipid, this.equip.usernm, this.equip.phone)
      let data = result.data
      if (data.ResultType == 0) {
        this.equip.usernm = ''
        this.equip.phone = ''
        this.$message({
          message: data.Message,
          type: 'success',
        })
        this.dialogFormVisible = false
        this.$emit('changeEquip')
        this.equipinfo()
      } else {
        this.$message({
          message: data.Message,
          type: 'error',
        })
      }
    },

    async handleCurrentChange(currentPage) {
      this.currentPage = currentPage
      this.equipinfo()
    },

    async downLoad() {
      this.excelName = `${this.equipmentnm}-${this.equipmentno}-${moment(this.dbt).format('YYYYMMDD')}-${moment(this.edt).format('YYYYMMDD')}.xls`
      let loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      let result1 = await equipinfo(this.equipid)
      let data = result1.data
      this.equipHead = data
      this.shareuser = data.shared
      let excelData = {
        filed: {},
        data: [],
      }
      excelData.filed[this.$t('detail.时间')] = 'createtime'
      excelData.filed[this.$t('detail.经度')] = 'z'
      excelData.filed[this.$t('detail.纬度')] = 'wd'

      this.equipHead.tp.map((n, index) => {
        excelData.filed[`"${n.tnm}"`] = `col${index}`
      })

      let result = await equiphistory(this.dbt, this.edt, this.equipid, 1, 60000)
      let data2 = result.data.total ? JSON.parse(result.data.data) : null
      loading.close()
      this.equipinfoList1 = []

      data2.map((item) => {
        let obj = []
        let temp = {}
        for (let i = 0; i < data.tp.length; i++) {
          obj.push(item['col' + i])
        }
        temp['info'] = item
        temp['list'] = obj

        this.equipinfoList1.push(temp)
      })

      this.equipinfoList1.map((n) => {
        let filter_filed = {}
        Object.values(excelData.filed).map((m) => {
          filter_filed[m] = n.info[m]
        })

        excelData.data.push(filter_filed)
      })
      this.json_fields = excelData.filed
      this.json_data = excelData.data
      if (excelData.data.length > 60000) {
        this.$alert(this.$t('detail.查询数据超过6万条'))
      }
      return excelData.data
    },
    async equipinfo() {
      this.isstyle = false
      let loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      try {
        this.equipid = this.$route.params.dId
        let result = await equipinfo(this.equipid)
        let data = result.data
        this.equipHead = data
        this.shareuser = data.shared
        loading.close()
        let result2 = await equiphistory(this.dbt, this.edt, this.equipid, this.currentPage)
        let data2 = result2.data.total ? JSON.parse(result2.data.data) : null
        if (data2) this.total = result2.data.total

        this.equipinfoList = []
        data2 &&
          data2.map((item) => {
            let obj = []
            let temp = {}
            for (let i = 0; i < data.tp.length; i++) {
              obj.push(item['col' + i])
            }
            // obj.push(0)
            // equipinfoList.push(obj)
            temp['info'] = item
            temp['list'] = obj

            this.equipinfoList.push(temp)
          })
        setTimeout(() => {
          this.setFixedBodyTop()
        }, 1000)
      } catch (error) {
        console.log(error)
      } finally {
        loading.close()
      }
    },
    async removeShare(eid, uid) {
      let result = await cancelshard(eid, uid)
      let data = result.data
      if (data.ResultType == 0) {
        this.equip.equipno = ''
        this.equip.usernm = ''
        this.equip.phone = ''
        this.$message({
          message: data.Message,
          type: 'success',
        })
        this.dialogFormVisible = false
        this.equipinfo()
        this.$emit('changeEquip')
      } else {
        this.$message({
          message: data.Message,
          type: 'error',
        })
      }
    },
    //导出表格
    async exportToExcel() {
      this.excelName = `${this.equipmentnm}-${this.equipmentno}-${moment(this.dbt).format('YYYYMMDD')}-${moment(this.edt).format('YYYYMMDD')}.xls`
      let loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      let result2 = await equiphistory(this.dbt, this.edt, this.equipid, 1, 60000)

      let result = await equipinfo(this.equipid)

      // this.equipinfo()
      //excel数据导出
      require.ensure([], () => {
        const { export_json_to_excel } = require('../vender/Export2Excel')
        var tHeader = [this.$t('detail.时间'), this.$t('detail.经度'), this.$t('detail.纬度')]
        var filterVal = ['createtime', 'jdt', 'wdt']
        var tHeader1 = []
        var filterVal1 = []
        // 循环头部
        this.equipHead.tp.map((n, index) => {
          tHeader1[index] = n
        })
        // 循环tHeader1里面的tnm
        this.tHeader1 = tHeader1
        tHeader1.map((v) => {
          return v.tnm
        })
        //循环出来的tnm重新组成一个tHeader2数组
        let tHeader2 = tHeader1.map((v) => {
          return v.tnm
        })

        //循环出来equipinfoList里面的数据
        let equipinfoList = JSON.parse(result2.data.data)
        loading.close()
        equipinfoList.map((n, index) => {
          filterVal1[index] = n
        })
        var a = []
        let data = result.data
        for (let i = 0; i < data.tp.length; i++) {
          a.push('col' + i)
        }
        var filterVal2 = [].concat(a)
        Array.prototype.push.apply(tHeader, tHeader2)
        Array.prototype.push.apply(filterVal, filterVal2)
        const data3 = this.formatJson(filterVal, equipinfoList)
        export_json_to_excel(tHeader, data3, this.excelName)
        // 111
      })
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => {
        return filterVal.map((j) => {
          return v[j]
        })
      })
    },
    //判断是否可配置参数
    async disConfigChange() {
      await this.equipinfo()
      if (this.shareuser.length === 0) {
        this.disConfig = false
        this.showData = true
      } else {
        this.disConfig = true
        this.dialogFormVisible = false
        this.showData = false
      }
      if (this.myequips) {
        this.disConfig = false
      }
    },
    //共享设备是否可以更改
    async dialog() {
      // if (this.shareuser.length === 0) {
      //   this.dialogFormVisible = true
      // } else {
      //   this.dialogFormVisible = false
      // }
      this.dialogFormVisible = true
    },
    setFixedBodyTop() {
      this.isstyle = true
      this.$nextTick(() => {
        // 先判断表格实例是否存在
        if (!this.$refs.myTable) {
          console.warn('未找到表格实例，请检查 ref="myTable" 是否正确')
          return
        }
        console.log(this.$refs.myTable, '表格实例')

        // 获取表格根元素
        const tableEl = this.$refs.myTable.$el
        // 获取目标元素
        const fixedHeader = tableEl.querySelector('.el-table__fixed-header-wrapper')
        const fixedBody = tableEl.querySelector('.el-table__fixed-body-wrapper')
        const fixed = tableEl.querySelector('.el-table__fixed')
        const bodywrapper = tableEl.querySelector('.el-table__body-wrapper')
        // el-table__fixed

        // 确保所有元素都存在
        if (!fixedHeader || !fixedBody || !bodywrapper) {
          console.warn('未找到固定表头/固定体/主体容器元素（可能表格无固定列）')
          return
        }

        // 计算高度并设置样式（带 !important）
        const headerHeight = fixedHeader.offsetHeight
        const bodyHeight = bodywrapper.offsetHeight
        fixedBody.style.setProperty('top', `${headerHeight}px`, 'important')
        fixedBody.style.setProperty('height', `${bodyHeight}px`, 'important')
        fixed.style.setProperty('height', `${bodyHeight + 79.45}px`, 'important')
        console.log('设置成功：', headerHeight, bodyHeight)
      })
    },
  },
  watch: {
    $route: function () {
      clearInterval(setTimeOpenMsg)
      this.currentPage = 1
      //this.equipid = this.$route.params.dId
      this.myequips = this.$route.query.myequips
      this.equipid = this.$route.query.equipid
      this.equipmentnm = this.$route.query.equipmentnm
      this.equipmentno = this.$route.query.equipmentno
      this.equipinfo()
      this.disConfigChange()

      // 调起notice以及intervel
      this.openNotice()
      this.openMsg()
    },
  },

  async mounted() {
    if (!getToken()) {
      this.$router.push('/login')
      return
    }

    await this.equipinfo()
    this.disConfigChange()
    // 调起notice以及intervel
    this.openNotice()
    this.openMsg()

    // 监听窗口大小变化，动态更新
    // window.addEventListener('resize', this.setFixedBodyTop)
  },
  destroyed() {
    clearInterval(setTimeOpenMsg)
    // window.removeEventListener('resize', this.setFixedBodyTop)
  },
}
</script>
<style lang="scss">
/*定义滚动条高宽及背景
 高宽分别对应横竖滚动条的尺寸*/

::-webkit-scrollbar {
  width: 4px;
  height: 4px;
  background-color: #f5f5f5;
}
/*定义滚动条轨道
 内阴影+圆角*/
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  background-color: #f5f5f5;
}
/*定义滑块
 内阴影+圆角*/
::-webkit-scrollbar-thumb {
  border-radius: 4px;
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
  background-color: #666;
}
.el-notification__content {
  max-height: 40vh;
  overflow-y: auto;
}
.fire-wrap {
  width: 250px;
  border-top: 1px solid #f1f1f1;
  padding-top: 5px;
  margin-top: 5px;
  .fire-row {
    display: flex;
    justify-content: flex-start;
    &-item {
      &:first-child {
        width: 80px;
      }
    }
  }
}
</style>
<style lang="scss" scoped>
#map {
  background: white;
  height: 90%;
}
.daochu {
  display: flex;
}
.word {
  width: 140px;
}
.table {
  border-left: 1px solid #f1f1f1;
  border-top: 1px solid #f1f1f1;
  border-collapse: collapse;

  td {
    border-right: 1px solid #f1f1f1;
    border-bottom: 1px solid #f1f1f1;
    padding: 8px 12px;
  }
}
.flexbox {
  display: flex;
}
.flexbox1 {
  display: flex;
  width: 450px;
  height: 50px;
}

.first {
  margin-right: 0px;
  width: 300px;
}
.second {
  margin-right: 0px;
  width: 300px;
}
.third {
  margin-right: 0px;
  width: 300px;
}
.fourth {
  margin-right: 0px;
  width: 300px;
}
.fifth {
  margin-right: 0px;
  width: 300px;
}
.sixth {
  margin-right: 0px;
  width: 300px;
}
.seventh {
  margin-right: 0px;
  width: 300px;
}
.eighth {
  margin-right: 0px;
  width: 300px;
}
.bb {
  margin-left: 30px;
  margin-top: 2px;
}
.cc {
  margin-left: 80px;
}
/*.aa {
  margin-left: 60px;
}


.ee {
  margin-left: 61px;
}*/
.btn-save {
  display: block;
  margin: 0 auto;
  width: 100px;
  height: 30px;
}
.box-container {
  display: flex;
  flex-direction: column;
  height: calc(100vh - 240px);
  overflow: auto;
}
::v-deep .el-table__body-wrapper {
  height: 80% !important;
}
::v-deep .el-table__fixed-body-wrapper {
  // top: 86px !important;
  // position: static !important;
  // height: 72% !important;
}
</style>
